module.exports = __webpack_public_path__ + "static/media/white-and-blue-concrete.d1b2165f.jpg";